import React from 'react';

const Desktop = () => {
  return <div></div>;
};

export default Desktop;
